import React, { useEffect } from "react";
import { Card, Button, Input, Row, Col, Form, Select } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { setFormFieldValue, filterOption } from "../../../../helpers/FormHelper";




const Search = ({ dispatch, countries, referenceTypes, initialFilters, clearLoading, searchLoading, setLoadingType }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            name: setFormFieldValue(initialFilters?.name),
            surname: setFormFieldValue(initialFilters?.surname),
            father_name: setFormFieldValue(initialFilters?.father_name),
            reference_type: setFormFieldValue(initialFilters?.reference_type),
            ref_name: setFormFieldValue(initialFilters?.ref_name),
            ref_surname: setFormFieldValue(initialFilters?.ref_surname),
            country: setFormFieldValue(initialFilters?.country),
            evidenca: setFormFieldValue(initialFilters?.evidenca),
        });
    }, [form, initialFilters]);


    const onSearch = () => {
        setLoadingType('search');
        const { name, surname, father_name, country, reference_type, ref_name, ref_surname, evidenca } = form.getFieldsValue();
        const requestFilters = {
            name: setFormFieldValue(name),
            surname: setFormFieldValue(surname),
            father_name: setFormFieldValue(father_name),
            reference_type: setFormFieldValue(reference_type),
            ref_name: setFormFieldValue(ref_name),
            ref_surname: setFormFieldValue(ref_surname),
            country: setFormFieldValue(country),
            evidenca: setFormFieldValue(evidenca)
        };
        const action = {
            type: "set_search_filters",
            payload: requestFilters,
        };
        dispatch(action);
    };


    const onClear = () => {
        setLoadingType('clear');
        const action = {
            type: "set_search_filters",
            payload: {},
        };
        dispatch(action);
        form.resetFields();
    };


    const onEnter = (event) => {
        if (event.key === "Enter") {
            onSearch();
        }
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Form
                    form={form}
                    layout="vertical"
                    name="advanced_search"
                    className="ant-advanced-search-form"
                    onKeyDown={onEnter}
                >
                    <Card style={{ borderRadius: "0" }} bodyStyle={{ paddingBottom: "5px" }} className="pb-0">
                        <Row gutter={24} align="bottom">
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="country" label="Shteti:">
                                    <Select
                                        showSearch
                                        allowClear
                                        optionFilterProp="children"
                                        filterOption={filterOption}
                                        placeholder="-Zgjidhni shtetin-"
                                    >
                                        {countries?.map((item) => (
                                            <Select.Option key={item?.id} value={item?.id}>
                                                {item?.country_name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="reference_type" label="Tipi i referencës:">
                                    <Select
                                        showSearch
                                        allowClear
                                        optionFilterProp="children"
                                        filterOption={filterOption}
                                        placeholder="-Zgjidhni opsionin-"
                                    >
                                        {referenceTypes?.map((item) => (
                                            <Select.Option key={item?.id} value={item?.id}>
                                                {item?.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="ref_name" label="Emri i referuesit:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="ref_surname" label="Mbiemri i referuesit:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="name" label="Emri:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="surname" label="Mbiemri:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="father_name" label="Atësia:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="evidenca" label="Evidenca:">
                                    <Select placeholder="-Zgjidhni opsionin-" optionFilterProp="children">
                                        <Select.Option value={null}>Të gjithë</Select.Option>
                                        <Select.Option value={true}>PO</Select.Option>
                                        <Select.Option value={false}>JO</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={18} lg={18} md={0} sm={0} xs={0} />
                            <Col xl={3} lg={3} md={6} sm={12} xs={12}>
                                <Form.Item>
                                    <Button
                                        block
                                        ghost
                                        type="primary"
                                        loading={searchLoading}
                                        icon={<SearchOutlined />}
                                        onClick={onSearch}
                                    >
                                        Kërko
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col xl={3} lg={3} md={6} sm={12} xs={12}>
                                <Form.Item>
                                    <Button
                                        block
                                        danger
                                        loading={clearLoading}
                                        icon={<ClearOutlined />}
                                        onClick={onClear}
                                    >
                                        Pastro
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Form>
            </Col>
        </Row>
    );
};

export default Search;